var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgValuenew2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3277",
    "data-name": "Group 3277",
    transform: "translate(-5098 -2052)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    transform: "translate(5098 2052)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(5128.074 2081.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3275",
    "data-name": "Group 3275",
    transform: "translate(0.118 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M44.668,19.961a3.437,3.437,0,0,0-1.9-5.863L32.27,12.574a2.1,2.1,0,0,1-1.582-1.149L28.982,7.967a.668.668,0,1,0-1.2.591l1.706,3.457a3.437,3.437,0,0,0,2.588,1.88L42.571,15.42A2.1,2.1,0,0,1,43.735,19l-7.593,7.4a3.437,3.437,0,0,0-.989,3.042L36.946,39.9A2.1,2.1,0,0,1,33.9,42.113l-1.69-.888V40.139a1.978,1.978,0,0,0-1.976-1.976h-.385V35.175a3.094,3.094,0,0,1,.766-1.816c1.782-1.767,2.727-3.268,2.62-6.136a27.678,27.678,0,0,0-.944-6V19.444a2.47,2.47,0,0,0-3.614-2.191,2.7,2.7,0,0,0-4.315-1.888,2.7,2.7,0,0,0-4.863.047,2.7,2.7,0,0,0-4.388,2.111V21.7a2.991,2.991,0,0,0-.359.261,6.933,6.933,0,0,0-1.92,3.469,10,10,0,0,0-.244,2.173,9.3,9.3,0,0,0,2.888,6.353.644.644,0,0,1,.17.434v3.774h-.048a1.978,1.978,0,0,0-1.976,1.976v1.085l-1.69.888A2.1,2.1,0,0,1,8.88,39.9l1.792-10.45a3.437,3.437,0,0,0-.989-3.042L2.091,19A2.1,2.1,0,0,1,3.256,15.42L13.748,13.9a3.437,3.437,0,0,0,2.588-1.88l4.692-9.508a2.1,2.1,0,0,1,3.769,0l1.621,3.288a.668.668,0,0,0,1.2-.591L26,1.916a3.437,3.437,0,0,0-6.164,0l-4.693,9.508a2.1,2.1,0,0,1-1.582,1.149L3.064,14.1a3.437,3.437,0,0,0-1.9,5.863l7.593,7.4a2.1,2.1,0,0,1,.6,1.86L7.563,39.672A3.437,3.437,0,0,0,12.55,43.3l1.068-.562v.9a1.978,1.978,0,0,0,1.976,1.976h2.822a.668.668,0,1,0,0-1.336H15.594a.641.641,0,0,1-.64-.64v-3.5a.641.641,0,0,1,.64-.64H30.232a.641.641,0,0,1,.64.64v3.5a.641.641,0,0,1-.64.64H21.5a.668.668,0,0,0,0,1.336h8.729a1.978,1.978,0,0,0,1.976-1.976v-.9l1.068.562a3.437,3.437,0,0,0,4.987-3.623L36.471,29.222a2.1,2.1,0,0,1,.6-1.86Zm-15.98-.638a1.136,1.136,0,0,1,2.265.122v4.171a1.136,1.136,0,0,1-2.272,0Zm-4.045-2.056a1.367,1.367,0,0,1,2.709.256l-.007,4.838a1.369,1.369,0,0,1-1.36,1.234,1.351,1.351,0,0,1-.677-.182,3.113,3.113,0,0,0,.055-1.073,1.229,1.229,0,0,0-.723-.987c0-.027,0-4.087,0-4.087Zm-4.07-.7a1.367,1.367,0,0,1,2.734,0l-.025,4.681H20.572V16.568Zm-4.128.956a1.367,1.367,0,1,1,2.734,0v3.725H16.689c-.082,0-.164,0-.245.01V17.523ZM28.511,35.175v2.989H16.978V34.39a1.977,1.977,0,0,0-.518-1.334A8.093,8.093,0,0,1,13.921,27.6a8.673,8.673,0,0,1,.213-1.882,5.646,5.646,0,0,1,1.48-2.737,1.663,1.663,0,0,1,1.075-.395h7.355a1.423,1.423,0,0,1-.657,1.379c-1.1.8-2.874.6-3.828.492-.152-.017-.284-.032-.395-.041a1.152,1.152,0,0,0-1.22.522.913.913,0,0,0,.1.955,7.946,7.946,0,0,0,.894.783,3.428,3.428,0,0,1,.541.707,3.738,3.738,0,0,1,.55,2.335.668.668,0,1,0,1.326.159A5.251,5.251,0,0,0,20,25.844a6.257,6.257,0,0,0,4.178-.8,3.354,3.354,0,0,0,.5-.45,2.695,2.695,0,0,0,2.819-.125,2.47,2.47,0,0,0,4.223.722c.088.671.151,1.365.178,2.083.081,2.166-.439,3.366-2.226,5.138A4.409,4.409,0,0,0,28.511,35.175Z",
    transform: "translate(-0.118 0)",
    fill: "#fff"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuenew2);
export default __webpack_public_path__ + "static/media/valuenew2.e3505c6ab438c9fe3f2ebacf9489fdae.svg";
export { ForwardRef as ReactComponent };